import { Pipe, PipeTransform } from '@angular/core';
import { Year } from '../year/year.model';
import { YearService } from '../year/year.service';

@Pipe({
    name: 'yearDescription'
})
export class YearDescriptionPipe implements PipeTransform {

    constructor(private yearService: YearService) { }

    transform(yearId: number, args?: string[]): any {

        let year: Year = this.yearService.allYears.find(year => year.Id == yearId);

        return year ? year.Description : '';
    }

}
